// Schuljahresgrenze Hessen (01.08.–31.07.) — Spiegel von server/lib/helpers.js
// (schuljahrFenster). Logik identisch halten. Fehlzeiten-Kennzahlen zählen nur das
// laufende Schuljahr; ältere Einträge bleiben erhalten und erscheinen unter "Vorjahre".
export const SCHULJAHR_BEGINN_MMDD = '08-01';

/** Welle Z4: Schuljahr überall kurz — „2026/2027“ → „2026/27“ (andere Werte unverändert) */
export function schuljahrKurz(label: string | null | undefined): string {
  const s = String(label ?? '');
  const m = s.match(/^(\d{4})\/(\d{4})$/);
  return m && Number(m[2]) === Number(m[1]) + 1 ? `${m[1]}/${m[2].slice(2)}` : s;
}

export interface SchuljahrFenster {
  von: string;      // 'YYYY-08-01'
  bis: string;      // 'YYYY+1-07-31'
  bisExkl: string;  // 'YYYY+1-08-01' — halb-offen: datum >= von && datum < bisExkl
  label: string;    // '2026/27'
}

export function schuljahrFensterAusLabel(label: string): SchuljahrFenster {
  const start = Number(String(label).slice(0, 4));
  return {
    von:     `${start}-${SCHULJAHR_BEGINN_MMDD}`,
    bis:     `${start + 1}-07-31`,
    bisExkl: `${start + 1}-${SCHULJAHR_BEGINN_MMDD}`,
    label:   `${start}/${String(start + 1).slice(2)}`,
  };
}

// datum: Date ODER 'YYYY-MM-DD…'-String (String direkt geparst → keine UTC-Verschiebung)
export function schuljahrFenster(datum: Date | string = new Date()): SchuljahrFenster {
  let jahr: number, mmdd: string;
  if (typeof datum === 'string') {
    jahr = Number(datum.slice(0, 4));
    mmdd = datum.slice(5, 10);
  } else {
    jahr = datum.getFullYear();
    mmdd = `${String(datum.getMonth() + 1).padStart(2, '0')}-${String(datum.getDate()).padStart(2, '0')}`;
  }
  const start = mmdd >= SCHULJAHR_BEGINN_MMDD ? jahr : jahr - 1;
  return schuljahrFensterAusLabel(String(start));
}

export function imSchuljahr(datum: string | null | undefined, fenster: SchuljahrFenster = schuljahrFenster()): boolean {
  if (!datum) return false;
  const d = String(datum).slice(0, 10);
  return d >= fenster.von && d < fenster.bisExkl;
}

/** Welle N2: frühere Schuljahre zur Auswahl (Vorjahresnote), neuestes zuerst — 'JJJJ/JJJJ' */
export function fruehereSchuljahre(anzahl = 4, datum: Date | string = new Date()): string[] {
  const start = Number(schuljahrFenster(datum).von.slice(0, 4));
  return Array.from({ length: anzahl }, (_, i) => `${start - 1 - i}/${start - i}`);
}
